{
    "DirectoryList_Column_Description": "Descrizione",
    "DirectoryList_Column_TelephoneNumber": "Numero di telefono",
    "DirectoryList_Add_Disabled_SelectTelSys": "Selezionare un server di telefonia per aggiungere una voce alla rubrica.",
    "DirectoryList_Add_Disabled_NoTelephonyFilter": "Disattiva il filtro \"nessun server di telefonia\" per aggiungere una voce alla rubrica.",
    "NAME": "Elenco directoryLingua"
}